<!-- eslint-disable -->
<template>
  <div v-if="isInitiailized" class="G_modal_container">
    <div class="G_modal" :class="{ G_hidden_element: activeModal!='default'}">
      <modal-header
        @event-close-child-modals="eventCloseChildModals"
        @event-close-modal="selfClose"
        :title="modalTitle">
      </modal-header>
      <hr>
      <div class="c3m3_main_container">
        <div class="w-30" style="margin-top: 8px;">
          <div class="c3m3_rules_title">
            <h3 class="c3m3_existing_rules_heading"></h3>
            <button 
              class="c2m4_buttons" 
              @click.stop="showCreateRuleModal"
            >Create New Rule</button>
          </div>
          <div class="c3m3_rules_list" v-if="C_ngpRulesList.length > 0">
            <span 
              v-for="rule in C_ngpRulesList"
              class="c3m3_rules_list_entry" 
              :class="{c3m3_selected: (DV_selectedRule && DV_selectedRule.uid == rule.uid)}"
              @click.stop="toggleSelectedRule(rule)"
            >
              <span>{{rule.name}}</span>
              <span 
                v-if="DV_selectedRule && DV_selectedRule.uid == rule.uid" 
                class="c3m3_rule_actions"
              >
                <i 
                  @click.stop="editRule(rule)" 
                  class="fa fa-pencil c3m3_edit_icon c3m3_rule_action_icon"
                ></i>
                <i 
                  @click.stop="confirmDeleteRule(rule.uid)" 
                  class="fa fa-trash c3m3_delete_icon c3m3_rule_action_icon"
                ></i>
              </span>
            </span>
          </div>
          <div class="c3m3_rules_list" v-else>
            No rules available to show.
          </div>
        </div>
        <div class="c3m3_rules_assignment_section">
          <div class="c3m3_rules_title">
            <h3 class="c3m3_rules_assignment_heading"></h3>
            <h4 class="p2s2_rule_joins_accronym_reference"></h4>
          </div>
          <div class="c3m3_rules_list" v-if="DV_selectedRule !== null && C_selectedRuleAssignments.length > 0">
            <p2s2c2-rule-join-entry
              v-for="entry in C_selectedRuleAssignments"
              :objectUid="entry.obj_uid"
              :objectAttributeUid="entry.obj_atr_uid"
              :ruleJoinUid="entry.uid"
              :doghouseFlag="entry.type_doghouse"
              :instantFlag="entry.type_instant"
              :reportFlag="entry.type_daily"
              :key="entry.obj_atr_uid"
            ></p2s2c2-rule-join-entry>
          </div>
        </div>
      </div>
    </div>
    <div 
      class="G_modal_container" 
      v-if="activeModal!='default'"
    >
      <p2s2m1-create-modify-rule
        v-if="activeModal=='p2s2m1'"
        :subItemIndex="1"
        :isModal="true"
        :subItemsList="subItemsList"
        :createEditFlag="DV_createEditFlag"
        :is-group-rule="true"
        :selected-rule-to-edit="DV_selectedRule"
        @event-close-modal="eventCloseModal"
        @event-sub-items-change="eventSubItemsChange"
        @event-parameter-change="eventParamsChange"
        @event-sub-items-loaded="eventSubItemsLoaded"
        @create-new-group-rule="eventSaveNewGroupRule"
        @hide-create-group-rule-modal="showDefaultModal"
      ></p2s2m1-create-modify-rule>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import ModalHeader from "../../p2ModalHeader";
import { bi10ModalTemplate } from "../../../../watchdog_includes/base_i10_UI_mixins";
import addRuleToNotificationGroup from "../../../../watchdog_includes/json_tasks/p2s9/p2s9t5";
import removeRuleFromNotificationGroup from "../../../../watchdog_includes/json_tasks/p2s9/p2s9t6";
import p2s2m1CreateModifyRule from "../p2s2m1CreateModifyRule";
import p2s2c2RuleJoinEntry from "../p2s2/p2s2c2RuleJoinEntry";

import AWN from "awesome-notifications";

export default {
  name: "c3m3ManageGroupRules",
  props: ['activeGroup', 'activeOrg', 'activeGroupName'],
  components: {
    ModalHeader,
    p2s2m1CreateModifyRule,
    p2s2c2RuleJoinEntry
  },
  mixins: [bi10ModalTemplate],
  data() {
    return {
      modalTitle:'Manage Group Rules',
      defaultModal:'default',
      DV_createEditFlag: 'create',
      DV_ngpRuleJoinsRef: {},
      DV_ngpRuleJoins: [],
      DV_ngpRulesInformationData: {},
      DV_ngpRulesAssignmentData: {},
      DV_selectedRule: null
    };
  },
  computed: {
    C_ngpRulesList() {
      var rules_list_data = [];

      for (let rule_uid in this.DV_ngpRuleJoins) {
        if (rule_uid in this.DV_ngpRulesInformationData === true) {
          rules_list_data.push(this.DV_ngpRulesInformationData[rule_uid])
        } else {
          let entry = {
          name: `Loading...`,
            uid: rule_uid,
            ruleLogic: "",
            description: ""
          }
          rules_list_data.push(entry)
        }
      }

      return rules_list_data
    },
    C_selectedRuleAssignments() {
      let assignments = [];

      if (this.DV_selectedRule && this.DV_selectedRule.uid in this.DV_ngpRulesAssignmentData === true) {
        for (let key in this.DV_ngpRulesAssignmentData[this.DV_selectedRule.uid]) {
          let entry = this.DV_ngpRulesAssignmentData[this.DV_selectedRule.uid][key];
          assignments.push(entry)
        }
      }

      return assignments;
    }
  },
  methods: {
    waitWatchdogReadyCallback() {
      window.G_watchdog_data.bi7InitNotificationGroupRuleJoins(this.activeGroup);
      window.G_watchdog_data.bi7InitNGPRuleAssignmentListener(this.activeGroup);
      this.DV_ngpRuleJoinsRef = window.G_watchdog_data.IV_ngp_rule_joins;
      this.DV_ngpRulesAssignmentData = window.G_watchdog_data.IV_ngp_rule_assignment_data[this.activeGroup];
      this.DV_ngpRulesInformationData = window.G_watchdog_data.IV_notification_group_rules_information;
    },
    showCreateRuleModal() {
      this.DV_createEditFlag = 'create';
      this.showModal("p2s2m1");
    },
    eventSaveNewGroupRule(rule_data) {
      if (rule_data == null || rule_data == undefined) {
        return;
      }

      if (rule_data.name == undefined || rule_data.name == null || rule_data.name.trim().length < 1) {
        this.$awn.warning("Invalid rule name, please enter valid rule name.");
        return;
      }

      var popup_options = {
        labels: {
          async: "Creating Notification Group Rule",
        },
        duration: 3000,
      };

      var rule_uid = null
      if (this.DV_createEditFlag === 'edit' && this.DV_selectedRule !== null) {
        rule_uid = this.DV_selectedRule.uid
      }

      let notifier = new AWN(popup_options);
      var resp = addRuleToNotificationGroup(
        window.G_firebase_auth.IV_email_address,
        window.G_firebase_auth.IV_id_token,
        window.G_watchdog_data.IV_user_info.uid,
        this.activeGroup,
        rule_data.name,
        rule_data.description,
        rule_data.rule_logic,
        this.DV_createEditFlag,
        rule_uid
      );

      notifier.async(resp,
        (res) => {
          notifier.success(`New Rule created/updated successfully...`);
          this.DV_createEditFlag = "";
          this.DV_selectedRule = null;
        },
        (error) => {
          notifier.alert("There was an error creating/updating notification group rule, Please try later.");
          this.DV_createEditFlag = "";
          this.DV_selectedRule = null;
        } 
      );
      
      this.showDefaultModal();
    },
    showDefaultModal() {
      this.DV_createEditFlag = '';
      this.showModal('default');
    },
    confirmDeleteRule(rule_uid) {
      var popup_options = { 
        labels : { 
          confirm: "Delete Notification Group Rule" 
        }, 
        modal: {
          okLabel: "Accept", 
          cancelLabel: "Decline" 
        },  
        position: "center"
      };
      
      let popup = new AWN(popup_options)
      popup.confirm("Are you sure you want to delete this rule?",
        function() {
          this.deleteRule(rule_uid);
        }.bind(this),
       function() { 
          // Cancel
        }.bind(this)
      );
    },
    deleteRule(rule_uid) {
      var popup_options = {
        labels: {
          async: "Deleting Notification Group Rule",
        },
        duration: 3000,
      };
      let notifier = new AWN(popup_options);
      var resp = removeRuleFromNotificationGroup(
        window.G_firebase_auth.IV_email_address,
        window.G_firebase_auth.IV_id_token,
        window.G_watchdog_data.IV_user_info.uid,
        this.activeGroup,
        rule_uid
      );

      notifier.async(resp,
        (res) => {
          notifier.success(`Rule has been deleted successfully...`);
        },
        (error) => {
          notifier.alert("There was an error Deleting notification group rule, Please try later.");
        } 
      );
    },
    editRule(rule) {
      this.DV_createEditFlag = 'edit';
      this.DV_selectedRule = rule;
      this.showModal("p2s2m1");
    },
    toggleSelectedRule(rule) {
      if (this.DV_selectedRule === null) {
        this.DV_selectedRule = rule;
        return;
      }

      if (this.DV_selectedRule.uid === rule.uid) {
        this.DV_selectedRule = null;
        return;
      }

      this.DV_selectedRule = rule;
    }
  },
  watch: {
    activeGroupName() {
      if (this.modalTitle.includes('Loading Group...') && this.activeGroupName.length && this.activeGroupName.length != 0) {
        this.modalTitle = this.modalTitle.replace("Loading Group...", this.activeGroupName);
      }
    },
    DV_ngpRuleJoinsRef: {
      handler() {
        if (!this.DV_ngpRuleJoinsRef[this.activeGroup]) {return;}

        let ngp_rules_joins = {}
        for (let rule_uid in this.DV_ngpRuleJoinsRef[this.activeGroup]) {
          ngp_rules_joins[rule_uid] = this.DV_ngpRuleJoinsRef[this.activeGroup][rule_uid];
        }
        this.DV_ngpRuleJoins = ngp_rules_joins;
      },
      deep: true
    }
  },
  beforeDestroy() {
    window.G_watchdog_data.bi7UnsubscribeSpecificListener("ngp_rule_joins", this.activeGroup);
    window.G_watchdog_data.bi7UnsubscribeSpecificListener("ngp_rule_assignments", this.activeGroup);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/p2Dashboard/p2s2notifications/p2s2m2/c3m3ManageGroupRules.vue